import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import Login from "./pages/login";
import Secure from "./pages/secure";

// import "../src/assets/css/bootstrap.min.css";
// import "../src/assets/css/material-dashboard.css";
// import "../src/assets1/css/material-dashboard.css";
// // import "../src/assets/css/"

// import "https://kit.fontawesome.com/42d5adcbca.js";

import { withRouter } from "react-router-dom";

import { logout } from "./redux/actions/auth";

import axios from "axios";
import "bootstrap/dist/js/bootstrap.js";
import "material-icons/iconfont/material-icons.css";
import "../src/assets/css1/bootstrap.css";
import "../src/assets/style.css";

export var common_axios = axios.create({
  baseURL: process.env.REACT_APP_COMMON_API_JOB_LOKESH_SIR,
  // baseURL: "https://hrms-api.altruistindia.com/",
});
export var common_axios_aayush = axios.create({
  baseURL: process.env.REACT_APP_COMMON_API_JOB_AAYUSH,
  // baseURL: "https://hrms-api.altruistindia.com/",
});

const App = (props) => {
  const Routes = Secure;
  const { history } = props;

  axios.interceptors.request.use(
    (req) => {
      // console.log({ req });

      return req;
    },
    (err) => {
      // console.log(err);
      return Promise.reject(err);
    }
  );

  const token1 = localStorage.getItem("jwtToken");
  const agentCode = localStorage.getItem("usernamelogged");
  common_axios.defaults.headers.common["X-API-KEY"] =
    "f83OJ3D2xF1Bg8vub9tLe1gHMzV76e8Tus9uPHvRVEU";
  common_axios_aayush.defaults.headers.common["agentcode"] = agentCode;
  common_axios_aayush.defaults.headers.common["Authorization"] = token1;
  common_axios_aayush.defaults.headers.common["channel"] = "web";

  // common_axios.defaults.headers.common["source"] = "web";
  // common_axios.defaults.headers.common["UserId"] = uid;

  // common_axios.interceptors.response.use(
  //   (res) => {
  //     if (
  //       res?.data?.status?.statusCode == 102 ||
  //       res?.data?.status?.statusCode == 400
  //     ) {
  //       localStorage.clear();
  //       history.replace("/");
  //     }
  //     return res;
  //   },
  //   (err) => {
  //     return Promise.reject(err);
  //   }
  // );
  // common_axios_aayush.interceptors.response.use(
  //   (res) => {
  //     if (
  //       res?.data?.status?.statusCode == 102 ||
  //       res?.data?.status?.statusCode == 400
  //     ) {
  //       localStorage.clear();
  //       // history.replace("/");
  //       window.location.href = `${process.env.REACT_APP_NSDL_COMMON_JOB}/login`;
  //     }
  //     return res;
  //   },
  //   (err) => {
  //     return Promise.reject(err);
  //   }
  // );
  // useEffect(() => {
  //   if (localStorage?.getItem("token")) {
  //     history.listen((newLocation, action) => {
  //       if (action === "PUSH") {
  //         if (
  //           newLocation.pathname !== this.currentPathname ||
  //           newLocation.search !== this.currentSearch
  //         ) {
  //           // Save new location
  //           this.currentPathname = newLocation.pathname;
  //           this.currentSearch = newLocation.search;

  //           // Clone location object and push it to history
  //           history.push({
  //             pathname: newLocation.pathname,
  //             search: newLocation.search,
  //           });
  //         }
  //       } else {
  //         // Send user back if they try to navigate back
  //         history.go(1);
  //       }
  //     });
  //   }
  // }, [localStorage?.getItem("token")]);

  return <Routes />;
};

const mapStateToProps = (state) => ({
  auth: state.authReducer.auth,
});

// const mapDispatchToProps = {};

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
